import { Card, Divider, Drawer, message, Modal, Table, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import TableLZM from '../../../components/design/table/TableLZM';
import { AddressGroup } from '../../../components/model/business/FieldsGroup';
import { useAuth } from '../../../../store/AuthContext/AuthContext';
import { PostScheduled } from '../../../components/model/posts/PostScheduled';
import { useFetch } from '../../../../hooks/useFetch/useFetch';
import { ScheduledDate } from './editFields/ScheduledDate';
import { DrawerPanelTitle, drawerPanelStyles } from '../../common/Drawers/DrawerPanelTitle';

export const PostSheduledDrawer = (props: { postScheduled: any, onFinish: any, onChange: any }) => {

  const [postLocationsData, setPostLocationsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [updateData, setUpdateData] = useState(false);
  const { projectGroup } = useAuth();

  useFetch(`${process.env.REACT_APP_API}/projects/` + projectGroup.project + '/' + projectGroup.group + `/postsScheduled/${props.postScheduled.id}`, {}, [updateData],
		(data) => {		    
      setPostLocationsData(data);
	});
  
  const columns = [
    {
      title: 'Title',
      key: 'title',      
      render: (record: any) => (
			  <Tag style={{borderRadius:'5px'}}>{record.title}</Tag>
			  )
    },
    {
    title: 'Ubicación',
    key: 'addressLine',
    render: (text: string, record: any) => (<AddressGroup record={record} />),
    dataIndex: 'addressLine'
    }
  ]

  return (
    <Drawer
      {...drawerPanelStyles}
      open={true}
      title={
        <DrawerPanelTitle
          title="Programación"
          locationsCount={props.postScheduled.post.locationsNames.length}
        />
      }
      placement="right"
      width={'55%'}
      onClose={() => props.onFinish()}>
                  
      <ScheduledDate postScheduled={props.postScheduled} onChange={() => {setUpdateData(!updateData); props.onChange()}}/>
      <div style={{ width: '90%', margin: '0px 5% 20px 5%'}}>           
        <PostScheduled postScheduled={props.postScheduled} onChange={() => {setUpdateData(!updateData); props.onChange()}}/>
      </div>
      
      <br/><br/>     			
      <h2 style={{color:'LightSlateGray'}}>Lista de locales:</h2>
      <TableLZM rowKey={'name'} columns={columns} dataSource={postLocationsData} loading={isLoading} showHeader={false}/>
    
    </Drawer>
  )
}